import { useEffect, useState } from 'react';
import { getCodeKeyMap } from '../utils/keyboardUtils';
export function useCodeKeyMap() {
    const [codeKeyMap, setCodeKeyMap] = useState({});
    useEffect(() => {
        getCodeKeyMap().then((map) => setCodeKeyMap(map));
    }, []);
    return codeKeyMap;
}
